<template>
    <div class="condition-wrapper" :class="{ error: !isValid }">
        <InputItem class="condition-inputs" :value="value.value" @change="changeHandler" :items="items" :hasAdd="false" :only="true" width="33%" />
        <i class="el-icon-circle-close condition-delete" @click="deleteHandler" v-show="!hiddenDelete"></i>
    </div>
</template>

<script>
import InputItem from "@/views/zhiji/components/multiInput/InputItem.vue";
import Select from "@/views/zhiji/components/multiInput/Select.vue";
import { objectRequiredField, checkRule } from "../../rules.js";
import Validation from "../../validation.js";

const requiredValidator = { fields: ["param", "op", "val"], validator: objectRequiredField };

export default {
    name: "Condition",
    props: ["value", "conditionParams", "hiddenDelete", "validation"],
    components: {
        InputItem
    },
    data() {
        return {
            isValid: true,
            message: "",
            myValidation: null
        };
    },
    computed: {
        items() {
            const inputsVal = this.value.value;
            const paramItem = {
                type: Select,
                name: "param",
                extendProps: {
                    placeholder: "请选择参数",
                    filterable: true,
                    valueKey: "value",
                    remoteMethod: this.conditionParams.getParamConfig
                },
                defaultData(items) {
                    items.param = "";
                },
                trigger: ["op", "val"] // 值改变会触发value的参数修改
            };
            const items = [paramItem];
            if (inputsVal.param) {
                const optionItem = {
                    type: Select,
                    name: "op",
                    extendProps: {
                        styles: { width: "140px" },
                        placeholder: "请选择操作",
                        options: this.conditionParams.getOptions(inputsVal.param)
                    },
                    defaultData(items) {
                        items.op = "";
                    },
                    triggerAction: items => {
                        if (!items.param) {
                            return { options: [] };
                        }
                        return { options: this.conditionParams.getOptions(items.param) };
                    },
                    trigger: ["val"]
                };
                items.push(optionItem);
            }
            if (inputsVal.param && inputsVal.op) {
                const typeConfig = this.conditionParams.getValueType(inputsVal.param, inputsVal.op);
                const { component, props } = this.getComponentByType(typeConfig.type);
                const valueItem = {
                    type: component,
                    name: "val",
                    extendProps: {
                        styles: { width: "220px" },
                        placeholder: typeConfig.placeholder || "请输入",
                        ...props,
                        ...(typeConfig.props || {})
                    },
                    defaultData(items) {
                        items.val = "";
                    },
                    triggerAction: items => {
                        // 重置
                    }
                };
                items.push(valueItem);
            }
            return items;
        }
    },
    created() {
        this.myValidation = new Validation({
            tiggerHanlder: () => this.validate(),
            propName: "condition"
        });
        this.validation && this.validation.addChild(this.myValidation);
    },
    destroyed() {
        this.myValidation && this.myValidation.destroy();
    },
    methods: {
        changeHandler(val) {
            const newValue = { ...this.value, value: val };
            !this.isValid && this.validate(val);
            this.$emit("change", newValue);
        },
        deleteHandler() {
            this.$emit("delete");
        },
        getComponentByType(type) {
            const map = {
                number: { component: "el-input-number", props: { "controls-position": "right", size: "small" } },
                bool: {
                    component: Select,
                    props: {
                        options: [
                            { label: "是", value: true },
                            { label: "否", value: false }
                        ]
                    }
                },
                option: { component: Select, props: { multiple: true } },
                time: {
                    component: "el-date-picker",
                    props: { type: "datetime", placeholder: "选择日期", align: "right", size: "small", key: type, valueFormat: "yyyy-MM-dd hh:mm:ss" }
                },
                datetimerange: {
                    component: "el-date-picker",
                    props: {
                        type: "datetimerange",
                        rangeSeparator: "至",
                        startPlaceholder: "开始日期",
                        endPlaceholder: "结束日期",
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                        key: type
                    }
                }
            };
            const def = { component: "el-input", props: {} };
            return map[type] || def;
        },
        validate(newValue) {
            const result = checkRule(newValue || this.value.value, [requiredValidator]);
            this.isValid = result.isValid;
            if (newValue) {
                this.emitValid();
            }
            return {
                isValid: this.isValid,
                message: this.message
            };
        },
        emitValid() {
            this.myValidation && this.myValidation.emit({ isValid: this.isValid, message: this.message });
        }
    }
};
</script>

<style lang="less" scoped>
.condition-wrapper {
    position: relative;
}
.condition-delete {
    font-size: 16px;
    position: absolute;
    top: 8px;
    right: -12px;
    &::before {
        color: #7a7e8e;
    }
}
.error {
    /deep/ .el-input__inner {
        border-color: #fe0931;
    }
}
</style>
